import { Location } from "history";

export const buildLoginRedirectTarget = (
	location: Pick<Location, "pathname" | "search" | "hash">
): string => `${location.pathname}${location.search}${location.hash}`;
